<template>
  <div>
    <Header />
    <div class="main margin-body">
      <!-- Aqui van las vistas cargadas -->
      <router-view></router-view>
      <b-button
        class="float-bottom"
        @click="toggleOptions"
      >
        <img src="/images/fga-contacto.jpg" alt="Ícono Personalizado" width="50"  height="50">
      </b-button>
      <div v-if="showOptions" class="options-container">
        <b-button
          v-for="option in options"
          :key="option.text"
          :variant="option.variant"
          v-b-tooltip.left
          :title="option.text"
          class="fab-option"
          @click="option.action"
        >
          <b-icon icon="whatsapp" font-scale="2.5"></b-icon>
        </b-button>
      </div>
    </div>

    <!--footer-->
    <Footer />
  </div>
</template>

<script>
import Header from "@/containers/layout/Header.vue";
import Footer from "@/containers/layout/Footer.vue";

export default {
  name: "Dashboard",
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      showOptions: false,
      options: [
        {
          text: "Hablemos por WhatsApp",
          icon: "fa fa-whatsapp",
          variant: "secondary",
          action: () => {
            this.abrirWhatsApp();
          },
        },
      ],
    };
  },
  methods: {
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
    abrirWhatsApp() {
      const texto = "Buen día, soy "+this.getUserName+" de "+this.intermediario;
      const textoCodificado = encodeURIComponent(texto);
      console.log(textoCodificado);
      window.open('https://api.whatsapp.com/send?phone=3013408415&text='+textoCodificado, '_blank');
    }
  },
  computed: {
    getUserName: function() {
      return this.$store.state.user.user
        ? this.$store.state.user.user.nombres +
            " " +
            this.$store.state.user.user.apellidos
        : "";
    },
    user() {
      return this.$store.state.user.user;
    },
    intermediario(){
      return this.user ? this.user.sigBanco.nombre_abr : "";
    }
  }
};
</script>
<style scoped>
.float-bottom {
  background-color: #ed9202;
  position: fixed;
  /* background-image: url("/images/fga-contacto-sticky-azul-oscuro.png"); */
  bottom: 20px;
  right: 20px;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  z-index: 1;
}

.options-container {
  position: fixed;
  bottom: 90px;
  right: 27px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.fab-option {
  background-color: #51b81d;
  margin-bottom: 10px;
  border-radius: 50%;
  width: 66px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
